import React from 'react';
import PropTypes from 'prop-types';
import FileUploadSectionViewer from './FileUploadSectionViewer';
import FileUploadSectionAdder from './FileUploadSectionAdder';


class FileUploadSection extends React.Component {

    // Lifecycle: Optimize performance for FileUploadSection
    // shouldComponentUpdate(nextProps) {
    //     return this.props.fileList !== nextProps.fileList;
    // }

    render() {
        // Depending on readonly prop, Viewer or Adder component will be rendered
        return (this.props.readonly) ?
            (<FileUploadSectionViewer
                name={this.props.name}
                fileList={this.props.fileList}
                getFileURL={this.props.getFileURL}
                onChangeField={this.props.onChangeField}
                isUpper={this.props.isUpper}
                sectionName={this.props.sectionName}
                readonly={this.props.readonly}
            />)
            :
            (<FileUploadSectionAdder
                name={this.props.name}
                fileList={this.props.fileList}
                getFileURL={this.props.getFileURL}
                onChangeField={this.props.onChangeField}
                uploadLimit={this.props.uploadLimit}
                sectionName={this.props.sectionName}
                readonly={this.props.readonly}
                error={this.props.error}
                label={this.props.sectionName}
            />);
    }
}

// PropTypes: For prop validation
FileUploadSection.propTypes = {
    name: PropTypes.string.isRequired,
    fileList: PropTypes.array,
    getFileURL: PropTypes.string,
    deleteFileURL: PropTypes.string,
    sectionName: PropTypes.string,                      // Required if readonly={false}
    onChangeField: PropTypes.func,                      // Required if readonly={false} 
    uploadLimit: PropTypes.number,                      // 0 is unlimited
    isUpper: PropTypes.bool,
    readonly: PropTypes.bool
};

// PropTypes: Defaulting value for optional props
FileUploadSection.defaultProps = {
    sectionName: '',
    onChangeField: () => { },
    uploadLimit: 0,
    readonly: false
};


export default FileUploadSection;